import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportingSearchField } from '@r1-compass-library/models/reporting/reporting-search.model';
import { AdvancedSearch } from '@r1-compass-library/models/search/advanced-search.model';

@Injectable({
    providedIn: 'root',
})
export class PlayReportingService {
    protected addSearchParams(search: object, customHttpOptions: { headers: HttpHeaders; params: HttpParams }) {
        for (const [key, value] of Object.entries(search)) {
            if (key === 'fields') {
                this.addSearchField(value, customHttpOptions, 'select');
            } else if (key === 'groupByFields') {
                this.addSearchField(value, customHttpOptions, 'groupBy');
            } else if (key === 'advancedSearch') {
                this.addAdvancedSearchParams(value, customHttpOptions);
            } else {
                if (value !== undefined) {
                    customHttpOptions.params = customHttpOptions.params.set(key, value);
                }
            }
        }
    }

    protected addSearchField(
        fields: ReportingSearchField[],
        httpOptions: { headers: HttpHeaders; params: HttpParams },
        type: 'select' | 'groupBy'
    ) {
        let objectName: string;
        if (type === 'select') {
            objectName = 'fields';
        } else if (type === 'groupBy') {
            objectName = 'groupByFields';
        }
        fields.forEach((field, i) => {
            for (const [key, value] of Object.entries(field)) {
                if (value) {
                    httpOptions.params = httpOptions.params.set(objectName + '[' + i + '].' + key, value);
                }
            }
        });
    }

    private addAdvancedSearchParams(
        advancedSearch: AdvancedSearch<unknown>[],
        httpOptions: { headers: HttpHeaders; params: HttpParams }
    ): void {
        advancedSearch.forEach((searchCriteria, i) => {
            httpOptions.params = httpOptions.params.set(`advancedSearch[${i}].property`, searchCriteria.property);
            httpOptions.params = httpOptions.params.set(`advancedSearch[${i}].value`, searchCriteria.value);
            if (searchCriteria.operator) {
                httpOptions.params = httpOptions.params.set(`advancedSearch[${i}].operator`, searchCriteria.operator);
            }
        });
    }
}
